export default  ['orderingPhysician', 'createPatient', 'patientHistory', 'specimenInformation']